import { inject, Injectable } from '@angular/core';

import { BaseFormat, CreateBaseFormat } from '@celum/formats/domain';

import { BaseFormatStore } from '../store';
import { BASE_FORMAT_SERVICE } from './base-formats.service';
import { FormatFormServiceBase } from './format-form-service-base';

@Injectable()
export class BaseFormatFormService extends FormatFormServiceBase<BaseFormat, CreateBaseFormat> {
  protected override readonly formatStore = inject(BaseFormatStore);
  protected override readonly formatDefinitionsService = inject(BASE_FORMAT_SERVICE);
  protected override readonly logPrefix = 'BaseFormatFormService';

  public generateFormatObject(): CreateBaseFormat {
    const common = this.buildCommonFormatFields();
    if (!common) {
      return null;
    }

    const { autoImportExcluded } = this.formatForm.getRawValue();

    return { ...common, autoImportExcluded };
  }
}
